import PropTypes from "prop-types";
import classNames from "classnames";

import "./HtmlText.css";

/**
 * Render HTML string as HTML
 * @returns
 */
export function HtmlText({
  className,
  element: HtmlTag,
  htmlString: __html = "",
  htmlFor,
}) {
  return (
    <HtmlTag
      className={classNames({
        "html-text": true,
        [className]: !!className,
      })}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: Content should be santizied in designer but could be good to do the same here in the future.
      dangerouslySetInnerHTML={{ __html }}
      htmlFor={htmlFor}
    />
  );
}

HtmlText.propTypes = {
  className: PropTypes.string,
  element: PropTypes.string.isRequired,
  htmlString: PropTypes.string,
  htmlFor: PropTypes.string,
};
